import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import produce from 'immer';
import {BlackboardData} from '@app/modules/blackboard/model/blackboardInfo';

export interface BlackboardStateModel {
  drawSegmentModel: BlackboardData;
  bbText: string;
  isOn: boolean;
  clearAllBB: boolean;
  pointer: boolean;
}

export namespace BlackboardAction {
  export class SetData {
    static readonly type = '[Blackboard] set x y coordinate';

    constructor(public drawSegmentModel: BlackboardData) {
    }
  }

  export class CleanAllBB {
    static readonly type = '[Blackboard] clean all bb';

    constructor(public clean: boolean) {
    }
  }

  export class ToggleBBPointer {
    static readonly type = '[Blackboard] toggle bb pointer';

    constructor(public bbPointer: boolean) {
    }
  }

  export class BBTextHandler {
    static readonly type = '[Blackboard] bb text handler';

    constructor(public text: string) {
    }
  }

  export class ToggleBBOnOff {
    static readonly type = '[Blackboard] toggle bb on off';

    constructor(public isOn: boolean) {
    }
  }
}

@State<BlackboardStateModel>({
  name: BlackboardState.storeName,
  defaults: BlackboardState.defaults
})

@Injectable()
export class BlackboardState {
  static readonly storeName = 'blackboardInfo';
  static readonly defaults: BlackboardStateModel = {
    drawSegmentModel: new BlackboardData(),
    bbText: '',
    isOn: false,
    clearAllBB: false,
    pointer: false
  };

  @Selector()
  static getBlackboardInfo(state: BlackboardStateModel) {
    return state;
  }

  @Action(BlackboardAction.SetData)
  setXYCoordinates(ctx: StateContext<BlackboardStateModel>, info: BlackboardAction.SetData) {
    ctx.setState(produce((state) => {
      state.drawSegmentModel = info.drawSegmentModel;
    }));
  }


  @Action(BlackboardAction.BBTextHandler)
  bbTextHandler(ctx: StateContext<BlackboardStateModel>, info: BlackboardAction.BBTextHandler) {
    ctx.setState(produce((state) => {
      state.bbText = info.text;
    }));
  }

  @Action(BlackboardAction.ToggleBBPointer)
  togglePointer(ctx: StateContext<BlackboardStateModel>, info: BlackboardAction.ToggleBBPointer) {
    ctx.setState(produce((state) => {
      state.pointer = info.bbPointer;
    }));
  }

  @Action(BlackboardAction.CleanAllBB)
  cleanAllBB(ctx: StateContext<BlackboardStateModel>, info: BlackboardAction.CleanAllBB) {
    ctx.setState(produce((state) => {
      state.clearAllBB = info.clean;
    }));
  }

  @Action(BlackboardAction.ToggleBBOnOff)
  toggleBBOnOff(ctx: StateContext<BlackboardStateModel>, info: BlackboardAction.ToggleBBOnOff) {
    ctx.setState(produce((state) => {
      state.isOn = info.isOn;
    }));
  }

}
